<template>
  <div>
      <h3>Manage SaaS Accounts</h3>
      <div class="row">
        <DisableSaas />
      </div>
      <div class="more-actions-toggle" @click="showAdvanceOptions = !showAdvanceOptions">{{showAdvanceOptions? 'Hide': 'Show'}} Advance Options (Only to be accessed by Saas L2 and L3)
        	{{showAdvanceOptions? '↑': '↓'}}
      </div>
      <div id="advance-saas" v-if="showAdvanceOptions">
        <div class="row">
          <DisableSaasMultiple />
        </div>
        <div class="row">
          <ResetSaasPlans/>
        </div>
        <div class="row">
          <ResetWelcomeEmailTemplateId/>
        </div>
      </div>
      <div class="row">
        <SaasTranscationDetails/>
      </div>
      <div class="row">
        <AgencyLocationDetails />
      </div>
      <div class="row">
        <LocationByStripeId />
      </div>
  </div>
</template>

<script>
import DisableSaas from "./DisableSaas.vue";
import DisableSaasMultiple from "./DisableSaasMultiple.vue";
import ResetSaasPlans from "./ResetSaasPlans.vue";
import ResetWelcomeEmailTemplateId from "./ResetWelcomeEmailTemplateId.vue"
import SaasTranscationDetails from './SaasTransactionDetails.vue'
import AgencyLocationDetails from './AgencyLocationDetails.vue'
import LocationByStripeId from './LocationByStripeId.vue'

export default {
  components: {
    DisableSaas,
    DisableSaasMultiple,
    ResetSaasPlans,
    ResetWelcomeEmailTemplateId,
    SaasTranscationDetails,
    AgencyLocationDetails,
    LocationByStripeId
  },
  data(){
    return {
      showAdvanceOptions: false,
    }
  }
}
</script>

<style>
.more-actions-toggle{
  cursor: pointer;
  text-align: center;
  margin: 32px 0px 16px;
  user-select: none;
  font-weight: 500;
}
</style>
